import { FC } from 'react';
import { SelectProps } from 'antd';

import { Select } from '~/components';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';

const LocationInput: FC<SelectProps<string>> = (props) => {
  const { data: handbook } = useHandbook();
  const handbookKeys = useHandbookKeys();

  const options = handbook?.handbooks
    ?.find((item) => item.key === handbookKeys.region)
    ?.values?.map((item) => ({ label: item.localizedValue, value: item.apiValue, key: item.key }));

  return (
    <Select
      options={[ { label: 'Other', value: 'OTHER' }]}
      showSearch
      allowClear
      {...props}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      autoComplete="none"
    />
  );
};

export default LocationInput;
